import React, { useContext, useEffect, useRef, useState } from 'react';
import { logOut } from '../auth/Auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { appContext } from '../../App';
import { AccountSwitcher } from '../AccountSwitcher';
import { useAccount } from '../../context/AccountContext';

interface UserMenuProps {
    settingsActive: boolean;
    setSettingsActive: (active: boolean) => void;
}

const UserMenu: React.FC<UserMenuProps> = ({
    settingsActive,
    setSettingsActive
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef2 = useRef<HTMLDivElement>(null);

    const {setActiveAccount} =useAccount()


    const { authUserName, authUserEmail } = useContext(appContext);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef2.current && !dropdownRef2.current.contains(event.target as Node)) {
                toggleDropdown();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    const handleLogout = () => {
        logOut(() => { });
        setActiveAccount('')
         localStorage.removeItem('activeAccount');
        setIsOpen(false);
    };

    const handleSettingsClick = () => {
        setSettingsActive(true);
        setIsOpen(false);
    };

    return (
        <div className="flex items-center md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
            <AccountSwitcher />

            <button
                type="button"
                className="flex justify-center items-center text-sm bg-white/20 dark:bg-slate-800/40 hover:bg-white/30 dark:hover:bg-slate-700/60 rounded-xl focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900 transition-all border border-white/10"
                id="user-menu-button"
                aria-expanded={isOpen}
                onClick={toggleDropdown}
            >
                <span className="sr-only">Open user menu</span>
                <div className="flex justify-center items-center w-8 h-8 md:w-11 md:h-11 text-lg md:text-2xl text-white">
                    <FontAwesomeIcon icon={faUser} className="opacity-90" />
                </div>
            </button>


            {isOpen && (
                <div
                    ref={dropdownRef2}
                    className="fixed top-20 right-5 z-50 w-64 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-2xl shadow-2xl overflow-hidden transition-all animate-in fade-in zoom-in-95 duration-200"
                >
                    <div className="px-5 py-4 bg-slate-50 dark:bg-slate-900/50 border-b border-slate-100 dark:border-slate-700">
                        <p className="font-bold text-sm text-slate-800 dark:text-slate-100 truncate"> {authUserName} </p>
                        <p className="text-xs text-slate-500 dark:text-slate-400 truncate mt-0.5"> {authUserEmail} </p>
                    </div>
                    <ul className="py-2" aria-labelledby="user-menu-button">
                        <li>
                            <button
                                className="w-full text-left px-5 py-2.5 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors font-medium flex items-center gap-3"
                                onClick={handleSettingsClick}
                            >
                                <span className="opacity-70">Settings</span>
                            </button>
                        </li>
                        <div className="h-px bg-slate-100 dark:bg-slate-700 my-2 mx-5" />
                        <li>
                            <button
                                className="w-full text-left px-5 py-2.5 text-sm text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-900/20 transition-colors font-bold flex items-center gap-3"
                                onClick={handleLogout}
                            >
                                <span className="">Sign out</span>
                            </button>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default UserMenu;
